import React from 'react';
import classNames from 'classnames';
import { MenuItem as MuiMenuItem } from '@material-ui/core';
import { makeStyles } from "../../styles/index";
import { Typography } from "../Typography/Typography";
import { useTheme } from "../../hooks/useTheme";
import { useLink } from "../../hooks/useLink";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        height: 48,
        padding: 0,
    },
    typographyWrapper: {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 2),
        color: 'inherit',
        textDecoration: 'none',
    },
    typography: {},
    light: {
        '&:hover, &$focusVisible': {
            backgroundColor: theme.palette.primary[50],
        },
        '&:active, &$selected, &$selected:hover, &$focusVisible:active': {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.dark.text.primary,
        },
        '&$disabled': {
            color: theme.palette.light.text.disabled,
        },
    },
    dark: {
        backgroundColor: theme.palette.dark.background.paper,
        color: theme.palette.dark.text.primary,
        '&:hover, &$focusVisible': {
            backgroundColor: theme.palette.dark.background.paper,
            color: theme.palette.primary.light,
        },
        '&:active, &$selected, &$selected:hover, &$focusVisible:active': {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.dark.text.primary,
        },
        '&$disabled': {
            color: theme.palette.light.text.disabled,
        },
    },
    disabled: {},
    selected: {},
    focusVisible: {},
}); }, { name: 'SnMenuItem' });
/**
 * メニュー要素コンポーネント。
 */
export var MenuItem = React.forwardRef(function (props, ref) {
    var _a;
    var tabIndex = props.tabIndex, autoFocus = props.autoFocus, selected = props.selected, onClick = props.onClick, children = props.children, className = props.className, disabled = props.disabled, style = props.style, _b = props.component, component = _b === void 0 ? 'div' : _b, to = props.to, href = props.href, isTargetBlank = props.isTargetBlank;
    var LinkComponent = useLink({ to: to, href: href, isTargetBlank: isTargetBlank });
    var hasLink = to || href;
    var theme = useTheme(props);
    var classes = useStyles(props);
    var rootClassName = classNames(classes.root, classes[theme.type], (_a = {},
        _a[classes.disabled] = disabled,
        _a[classes.selected] = selected,
        _a), className);
    return (React.createElement(MuiMenuItem, { disableRipple: true, ref: ref, className: rootClassName, focusVisibleClassName: classes.focusVisible, tabIndex: tabIndex, autoFocus: autoFocus, onClick: onClick, disabled: disabled, style: style, selected: selected }, hasLink ? (React.createElement(LinkComponent, { className: classes.typographyWrapper },
        React.createElement(Typography, { variant: "body2", component: component, className: classes.typography }, children))) : (React.createElement("div", { className: classes.typographyWrapper },
        React.createElement(Typography, { variant: "body2", component: component, className: classes.typography }, children)))));
});
